export default "__VITE_ASSET__EwM5m3Jo__"